import React from "react";
import './ImageMisc.sass';

type PngIconType = 'attackBonus'|'breweryParty'|'cavalryBonusTime'|'clay'|'clayBonus'|'constructionTime'|'crannyCap'|'crop'|'cropBonus'|'culturePoints'|'defenceBonus'|'defenceFlat'|'egyptian'|'freeCrop'|'gaul'|'granaryCap'|'healTime'|'hun'|'infantryBonusTime'|'iron'|'ironBonus'|'lumberBonus'|'maxShips'|'maxTraps'|'merchantCap'|'merchants'|'natar'|'oasis'|'oasisBonus'|'play'|'population'|'residenceBonusTime'|'roman'|'siegeBonusTime'|'spartan'|'stabilityBonus'|'strengthAttack'|'teahouseParty'|'teuton'|'time'|'townhallBigParty'|'townhallSmallParty'|'troopSpeed'|'troopVisibility'|'warehouseCap'|'wood'|'allResources'|'viking'
type SvgIconType = 'sum'

export type IconType = PngIconType|SvgIconType;
export type IconSize = 16|24|32;

type Props = {
    type: IconType,
    size: IconSize,
}

type SvgProps = Omit<Props, 'type'>;

export default function ImageMisc({ type, size }: Props) {
    switch (type) {
        case 'sum':
            return <SvgSum size={size} />
        default:
            return <i className={`travianImageMisc size-${size} icon-${type}`}></i>
    }
}

function SvgMerchants({ size }: SvgProps) {
    return <svg viewBox="0 0 48.58 50" className={`travianSvgMisc size-${size}`}>
        <path d="M31.04 19.12c-.2 2.47-.65 4.14-1.76 5.23-.01.13-.02.27-.03.43-.22.28-.37 1.24-.49 2.07 0 0 .63 1.43 1.88 3.16-3.87 2.53-6.32 7.19-6.58 11.04-.2 2.62.39 4.84 1.76 6.62H.34S-.3 36.62.18 36.31c3.27-2.15 15.4-7.15 15.4-7.15l1.63-2.3c-.03-.99-.09-2.17-.12-2.51-1.11-1.09-1.57-2.76-1.76-5.23-2.35-1.24-2.53-5.16-2.46-7.05.07-1.89 1.61-1.89 2.27-1.31-.33-3.27-.88-5.09 1.35-8.07C17.95.74 20.32 0 23.21 0s5.24.74 6.69 2.69c2.23 2.98 1.68 4.8 1.35 8.07.65-.58 2.31-.42 2.37 1.47.06 1.89-.22 5.65-2.57 6.89Zm17.51 22.15c-.15-2.15-1.14-4.72-2.8-6.83-.59-.75-1.25-1.43-2-2.03-.93-.74-1.97-1.33-3.11-1.69 0 0 2.55-2.37 2.37-3.34-.18-.97-1.85-2.02-1.85-2.02l-.55-1.19s-.5-1.07-3.41-1.01c-2.91-.06-3.54.97-3.54.97l-.42 1.23s-1.67 1.05-1.85 2.02c-.09.52.6 1.45 1.26 2.19.57.64 1.11 1.15 1.11 1.15-4.66 1.49-7.65 6.68-7.91 10.55-.24 3.13.91 5.16 2.62 6.46 2.27 1.72 5.54 2.18 7.92 2.25h1.6c4.17-.13 11.09-1.43 10.54-8.71Z" />
    </svg>
}

function SvgSum({ size }: SvgProps) {
    return <svg viewBox="0 0 82 100" className={`travianSvgMisc size-${size}`}>
        <path d="M82 23V0H0v17l28 33L0 83v17h82V76H65v7H22l27-33-27-33h43v6h17z" />
    </svg>
}
